import React from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./custom.css";
import usePageMeta from "../../usePageMeta";

// Fehlerseite für unbekannte Adressen (Route "*" in App.js).
// scripts/prerender.mjs rendert sie nach build/404/index.html; nginx liefert sie mit Status 404 aus.
function NotFound() {
  usePageMeta({
    title: "Seite nicht gefunden | Forst & Flur",
    description:
      "Die aufgerufene Seite gibt es bei Forst & Flur nicht (mehr). Hier geht es zur Startseite, zu den Leistungen und zum Kontakt.",
    robots: "noindex, follow",
  });

  const nachOben = () => window.scrollTo(0, 0);

  return (
    <div>
      <div className="ff-page-hero ff-page-hero--compact">
        <div className="ff-page-hero__content">
          <span className="ff-eyebrow">Fehler 404</span>
          <h1 className="ff-page-hero__title">Seite nicht gefunden</h1>
        </div>
      </div>
      <div className="custom-dark-green text-white">
        <Container className="py-5">
          <Row className="justify-content-center">
            <Col xs={12} lg={9} className="ff-legal">
              <p>
                Diese Seite gibt es leider nicht oder nicht mehr. Vielleicht hat sich die Adresse geändert oder
                sie wurde falsch eingegeben.
              </p>
              <div className="d-flex flex-wrap gap-3">
                <Link to="/" className="btn-ff-primary" onClick={nachOben}>
                  Zur Startseite
                </Link>
                <Link to="/kontakt" className="btn-ff-outline" onClick={nachOben}>
                  Kontakt
                </Link>
              </div>
              <h2 className="ff-article-h3">Unsere Leistungen</h2>
              <div className="d-flex flex-wrap gap-3">
                <Link to="/baumpflege" className="btn-ff-outline" onClick={nachOben}>
                  Baumpflege
                </Link>
                <Link to="/mulchen" className="btn-ff-outline" onClick={nachOben}>
                  Landschaftspflege
                </Link>
                <Link to="/baumfaellung" className="btn-ff-outline" onClick={nachOben}>
                  Baumfällung
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default NotFound;
